import React, { useState, useEffect, useContext } from 'react';
import { FaCode, FaLaptopCode, FaGamepad, FaBook, FaPlay, FaPause, FaExpand, FaCompress, FaGraduationCap, FaRoad, FaStar, FaUsers, FaClock, FaCheckCircle, FaTrash } from 'react-icons/fa';
import { useDarkMode } from '../../contexts/DarkModeContext';
import styles from './LearnProgramming.module.css';

const LearnProgramming = () => {
    const { isDarkMode } = useDarkMode();
    const [activeTab, setActiveTab] = useState('scratch');
    const [selectedGame, setSelectedGame] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [code, setCode] = useState(`// اكتب كودك هنا
console.log("مرحباً بالعالم!");

function greet(name) {
    return "أهلاً وسهلاً " + name;
}

console.log(greet("أحمد"));`);

    const [htmlCode, setHtmlCode] = useState(`<!DOCTYPE html>
<html dir="rtl" lang="ar">
<head>
    <meta charset="UTF-8">
    <title>صفحة HTML</title>
    <style>
        body { font-family: Arial, sans-serif; padding: 20px; }
        .container { max-width: 600px; margin: 0 auto; }
        h1 { color: #667eea; }
        .btn { background: #667eea; color: white; padding: 10px 20px; border: none; border-radius: 5px; cursor: pointer; }
    </style>
</head>
<body>
    <div class="container">
        <h1>مرحباً بك في محرر HTML!</h1>
        <p>هذا مثال على صفحة HTML بسيطة</p>
        <button class="btn" onclick="alert('أهلاً وسهلاً!')">اضغط هنا</button>
    </div>
</body>
</html>`);
    const [output, setOutput] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState('javascript');


    // ألعاب Scratch
    const programmingGames = [
        {
            id: 1,
            title: "CodeCombat",
            description: "تعلم البرمجة بلعب لعبة المغامرة",
            difficulty: "مبتدئ",
            duration: "20 دقيقة",
            players: "20M+",
            rating: 4.7,
            url: "https://codecombat.com/play",
            iframeUrl: "https://codecombat.com/play"
        },
        {
            id: 2,
            title: "Blockly Games",
            description: "ألغاز برمجية تفاعلية من Google",
            difficulty: "متوسط",
            duration: "25 دقيقة",
            players: "5M+",
            rating: 4.6,
            url: "https://blockly.games/",
            iframeUrl: "https://blockly.games/maze"
        },
        {
            id: 3,
            title: "Tynker",
            description: "تعلم البرمجة مع Minecraft",
            difficulty: "متوسط",
            duration: "30 دقيقة",
            players: "10M+",
            rating: 4.8,
            url: "https://www.tynker.com/",
            iframeUrl: "https://www.tynker.com/ide"
        },

    ];

    // مسارات البرمجة
    const programmingPaths = [
        {
            id: 1,
            title: "الفرونت إند",
            description: "تعلم تطوير واجهات الويب",
            icon: "🌐",
            languages: ["HTML", "CSS", "JavaScript", "React.js", "Vue.js", "Angular"],
            difficulty: "متوسط",
            duration: "6-8 أشهر"
        },
        {
            id: 2,
            title: "الباك إند",
            description: "تعلم تطوير الخوادم وقواعد البيانات",
            icon: "⚙️",
            languages: ["Python", "Node.js", "PHP", "Java", "C#", "SQL"],
            difficulty: "متقدم",
            duration: "8-12 شهر"
        },
        {
            id: 3,
            title: "تطوير الألعاب",
            description: "تعلم برمجة الألعاب التفاعلية",
            icon: "🎮",
            languages: ["C++", "C#", "Unity", "Unreal Engine", "GameMaker"],
            difficulty: "متقدم",
            duration: "12-18 شهر"
        },
        {
            id: 4,
            title: "تطوير تطبيقات الموبايل",
            description: "تعلم برمجة تطبيقات الهواتف",
            icon: "📱",
            languages: ["React Native", "Flutter", "Swift", "Kotlin", "Java"],
            difficulty: "متوسط",
            duration: "8-10 أشهر"
        }
    ];

    // مصادر التعلم - قنوات يوتيوب
    const learningResources = [
        {
            id: 1,
            title: "Elzero Web School",
            type: "قناة يوتيوب",
            description: "أفضل قناة لتعلم البرمجة باللغة العربية - أسامة الزيرو",
            rating: 4.9,
            subscribers: "2.5M+",
            url: "https://www.youtube.com/@ElzeroWebSchool"
        },
        {
            id: 2,
            title: "GODZILLA",
            type: "قناة يوتيوب",
            description: "قناة تعليمية متخصصة في البرمجة والتطوير",
            rating: 4.8,
            subscribers: "500K+",
            url: "https://www.youtube.com/@GODZILLA"
        },
        {
            id: 3,
            title: "Codezilla",
            type: "قناة يوتيوب",
            description: "تعلم البرمجة بطريقة سهلة وممتعة",
            rating: 4.7,
            subscribers: "300K+",
            url: "https://www.youtube.com/@Codezilla"
        },
        {
            id: 4,
            title: "Programming with Mosh",
            type: "قناة يوتيوب",
            description: "دروس برمجة احترافية باللغة الإنجليزية",
            rating: 4.9,
            subscribers: "3.2M+",
            url: "https://www.youtube.com/@programmingwithmosh"
        },
        {
            id: 5,
            title: "Traversy Media",
            type: "قناة يوتيوب",
            description: "دروس برمجة ويب حديثة ومتطورة",
            rating: 4.8,
            subscribers: "2.1M+",
            url: "https://www.youtube.com/@TraversyMedia"
        }
    ];

    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen);
    };

    const runCode = () => {
        try {
            if (selectedLanguage === 'javascript') {
                // تشغيل JavaScript
                const originalConsoleLog = console.log;
                let logs = [];
                
                console.log = (...args) => {
                    logs.push(args.join(' '));
                };
                
                eval(code);
                
                console.log = originalConsoleLog;
                setOutput(logs.join('\n'));
            } else if (selectedLanguage === 'python') {
                // محاكاة Python
                setOutput('Python سيتم دعمه قريباً...');
            } else if (selectedLanguage === 'html') {
                // عرض HTML
                const outputDiv = document.createElement('div');
                outputDiv.innerHTML = code;
                
                // إزالة أي scripts خطيرة
                const scripts = outputDiv.querySelectorAll('script');
                scripts.forEach(script => script.remove());
                
                // عرض HTML كـ text
                setOutput(`HTML Output:\n${outputDiv.innerHTML}\n\nRaw HTML:\n${code}`);
            }
        } catch (error) {
            setOutput(`خطأ: ${error.message}`);
        }
    };

    const clearOutput = () => {
        setOutput('');
    };

    const updateCodeForLanguage = (language) => {
        if (language === 'html') {
            setCode(htmlCode);
        } else if (language === 'javascript') {
            setCode(`// اكتب كودك هنا
console.log("مرحباً بالعالم!");

function greet(name) {
    return "أهلاً وسهلاً " + name;
}

console.log(greet("أحمد"));`);
        } else if (language === 'python') {
            setCode(`# اكتب كودك هنا
print("مرحباً بالعالم!")

def greet(name):
    return f"أهلاً وسهلاً {name}"

print(greet("أحمد"))`);
        }
    };

    return (
        <div className={`${styles.container} ${isDarkMode ? styles.darkMode : ''}`} style={{padding : '140px 0'}}>
            {/* Header */}
            <div className={`${styles.header} ${isDarkMode ? styles.darkMode : ''}`}>
                <div className={styles.headerContent}>
                    <div className={styles.titleSection}>
                        <FaCode className={styles.headerIcon} />
                        <h1>تعلم البرمجة مع علمني</h1>
                        <p>ابدأ رحلتك في عالم البرمجة مع أفضل الأدوات والموارد</p>
                    </div>
                    <div className={styles.headerStats}>
                        <div className={styles.stat}>
                            <FaUsers className={styles.statIcon} />
                            <span>+5000 طالب</span>
                        </div>
                        <div className={styles.stat}>
                            <FaStar className={styles.statIcon} />
                            <span>4.9/5 تقييم</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Navigation Tabs */}
            <div className={styles.navigationTabs}>
                <button
                    className={`${styles.navTab} ${activeTab === 'scratch' ? styles.activeNavTab : ''}`}
                    onClick={() => setActiveTab('scratch')}
                >
                    <FaGamepad className={styles.tabIcon} />
                    ألعاب البرمجة
                </button>
                <button
                    className={`${styles.navTab} ${activeTab === 'paths' ? styles.activeNavTab : ''}`}
                    onClick={() => setActiveTab('paths')}
                >
                    <FaRoad className={styles.tabIcon} />
                    مسارات البرمجة
                </button>
                <button
                    className={`${styles.navTab} ${activeTab === 'resources' ? styles.activeNavTab : ''}`}
                    onClick={() => setActiveTab('resources')}
                >
                    <FaBook className={styles.tabIcon} />
                    مصادر التعلم
                </button>
                <button
                    className={`${styles.navTab} ${activeTab === 'editor' ? styles.activeNavTab : ''}`}
                    onClick={() => setActiveTab('editor')}
                >
                    <FaCode className={styles.tabIcon} />
                    محرر الكود
                </button>
            </div>

            {/* Main Content */}
            <div className={styles.mainContent}>
                {activeTab === 'scratch' && (
                    <div className={`${styles.scratchSection} ${isDarkMode ? styles.darkMode : ''}`}>
                        <div className={styles.gamesList}>
                            <h3>ألعاب البرمجة التفاعلية</h3>
                            <div className={styles.gamesGrid}>
                                {programmingGames.map((game, index) => (
                                    <div
                                        key={game.id}
                                        className={`${styles.gameCard} ${selectedGame === index ? styles.selectedGame : ''}`}
                                        onClick={() => setSelectedGame(index)}
                                    >
                                        <div className={styles.gameHeader}>
                                            <span className={styles.gameIcon}>🎮</span>
                                            <div className={styles.gameDifficulty}>
                                                                                            <span className={`${styles.difficultyBadge} ${game.difficulty === 'مبتدئ' ? styles.beginner : game.difficulty === 'متوسط' ? styles.intermediate : styles.advanced}`}>
                                                {game.difficulty}
                                            </span>
                                            </div>
                                        </div>
                                        <h4>{game.title}</h4>
                                        <p>{game.description}</p>
                                        <div className={styles.gameStats}>
                                            <span className={styles.duration}>
                                                <FaClock className={styles.statIcon} />
                                                {game.duration}
                                            </span>
                                            <span className={styles.players}>
                                                <FaUsers className={styles.statIcon} />
                                                {game.players}
                                            </span>
                                            <span className={styles.rating}>
                                                <FaStar className={styles.starIcon} />
                                                {game.rating}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className={styles.scratchWorkspace}>
                            <div className={styles.workspaceHeader}>
                                <h3>CodeCombat</h3>
                                <div className={styles.workspaceControls}>
                                    <button
                                        className={styles.controlBtn}
                                        onClick={() => {}}
                                    >
                                        <FaPlay />
                                    </button>
                                                                    <button
                                    className={styles.controlBtn}
                                    onClick={toggleFullscreen}
                                >
                                    {isFullscreen ? <FaCompress /> : <FaExpand />}
                                </button>
                                </div>
                            </div>
                            <div className={styles.iframeContainer}>
                                <iframe
                                    src={programmingGames[selectedGame].iframeUrl}
                                    title={programmingGames[selectedGame].title}
                                    className={`${styles.gameIframe} ${isFullscreen ? styles.fullscreen : ''}`}
                                    allowtransparency="true"
                                    frameBorder="0"
                                    scrolling="no"
                                    allowFullScreen
                                />
                            </div>
                            <div className={styles.gameInstructions}>
                                <h4>تعليمات اللعبة:</h4>
                                <ul>
                                    <li>اكتب كود JavaScript لتحريك البطل</li>
                                    <li>اجمع الجواهر وتجنب الأعداء</li>
                                    <li>استخدم الحلقات والشروط</li>
                                    <li>اصنع دوال لتنظيم الكود</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'paths' && (
                    <div className={`${styles.pathsSection} ${isDarkMode ? styles.darkMode : ''}`}>
                        <div className={styles.pathsHeader}>
                            <h2>مسارات تعلم البرمجة</h2>
                            <p>اختر المسار المناسب لك وابدأ رحلتك في عالم البرمجة</p>
                        </div>
                        
                        <div className={styles.pathsGrid}>
                            {programmingPaths.map(path => (
                                <div key={path.id} className={styles.pathCard}>
                                    <div className={styles.pathHeader}>
                                        <span className={styles.pathIcon}>{path.icon}</span>
                                        <div className={styles.pathInfo}>
                                            <h3>{path.title}</h3>
                                            <p>{path.description}</p>
                                        </div>
                                    </div>
                                    
                                                                         <div className={styles.pathDetails}>
                                         <div className={styles.pathMeta}>
                                             <span className={styles.difficulty}>المستوى: {path.difficulty}</span>
                                             <span className={styles.duration}>المدة: {path.duration}</span>
                                         </div>
                                         
                                         <div className={styles.languagesList}>
                                             <h4>اللغات والتقنيات:</h4>
                                             <div className={styles.languagesGrid}>
                                                 {path.languages.map((language, index) => (
                                                     <span key={index} className={styles.languageTag}>
                                                         {language}
                                                     </span>
                                                 ))}
                                             </div>
                                         </div>
                                         
                                         <a 
                                             href="https://www.youtube.com/channel/UCSNkfKl4cU-55Nm-ovsvOHQ" 
                                             target="_blank" 
                                             rel="noopener noreferrer"
                                             className={styles.continueBtn}
                                         >
                                             ابدأ التعلم
                                         </a>
                                     </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {activeTab === 'resources' && (
                    <div className={styles.resourcesSection}>
                        <div className={styles.resourcesHeader}>
                            <h2>مصادر التعلم</h2>
                            <p>مجموعة متنوعة من الموارد التعليمية لمساعدتك في رحلة التعلم</p>
                        </div>
                        
                        <div className={styles.resourcesGrid}>
                            {learningResources.map(resource => (
                                <div key={resource.id} className={styles.resourceCard}>
                                    <div className={styles.resourceType}>
                                        <span className={styles.typeBadge}>{resource.type}</span>
                                    </div>
                                    <h3>{resource.title}</h3>
                                    <p>{resource.description}</p>
                                    <div className={styles.resourceStats}>
                                        <span className={styles.rating}>
                                            <FaStar className={styles.starIcon} />
                                            {resource.rating}
                                        </span>
                                        <span className={styles.subscribers}>
                                            <FaUsers className={styles.statIcon} />
                                            {resource.subscribers}
                                        </span>
                                    </div>
                                    <a 
                                        href={resource.url} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className={styles.watchBtn}
                                    >
                                        مشاهدة القناة
                                    </a>
                                </div>
                            ))}
                        </div>
                        
                        <div className={styles.additionalResources}>
                            <h3>موارد إضافية</h3>
                            <div className={styles.resourcesList}>
                                <a href="https://www.youtube.com/playlist?list=PLDoPjvoNmBAzTdJd5Nfym1b3j4iI1DTYN" target="_blank" rel="noopener noreferrer" className={styles.resourceItem}>
                                    <FaGraduationCap className={styles.resourceIcon} />
                                    <span>دورات مجانية على YouTube</span>
                                </a>
                                <a href="https://github.com/EbookFoundation/free-programming-books" target="_blank" rel="noopener noreferrer" className={styles.resourceItem}>
                                    <FaBook className={styles.resourceIcon} />
                                    <span>كتب برمجة مجانية</span>
                                </a>
                                <a href="https://github.com/topics/programming-projects" target="_blank" rel="noopener noreferrer" className={styles.resourceItem}>
                                    <FaCode className={styles.resourceIcon} />
                                    <span>مشاريع عملية</span>
                                </a>
                                <a href="https://stackoverflow.com/" target="_blank" rel="noopener noreferrer" className={styles.resourceItem}>
                                    <FaUsers className={styles.resourceIcon} />
                                    <span>مجتمعات برمجة</span>
                                </a>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'editor' && (
                    <div className={`${styles.editorSection} ${isDarkMode ? styles.darkMode : ''}`}>
                        <div className={styles.editorHeader}>
                            <h2>محرر الكود التفاعلي</h2>
                            <p>اكتب كودك وجربه مباشرة</p>
                        </div>
                        
                        <div className={styles.editorContainer}>
                            <div className={styles.editorToolbar}>
                                <select 
                                    value={selectedLanguage} 
                                    onChange={(e) => setSelectedLanguage(e.target.value)}
                                    className={styles.languageSelect}
                                >
                                    <option value="javascript">JavaScript</option>
                                    <option value="python">Python</option>
                                    <option value="html">HTML</option>
                                </select>
                                <button onClick={runCode} className={styles.runBtn}>
                                    <FaPlay className={styles.runIcon} />
                                    تشغيل
                                </button>
                                <button onClick={clearOutput} className={styles.clearBtn}>
                                    <FaTrash className={styles.clearIcon} />
                                    مسح
                                </button>
                            </div>
                            
                            <div className={styles.editorContent}>
                                <div className={styles.codeEditor}>
                                    <div className={styles.editorHeader}>
                                        <h4>الكود</h4>
                                    </div>
                                    <textarea
                                        value={code}
                                        onChange={(e) => setCode(e.target.value)}
                                        className={styles.codeTextarea}
                                        placeholder="اكتب كودك هنا..."
                                        spellCheck="false"
                                    />
                                </div>
                                
                                <div className={styles.outputPanel}>
                                    <div className={styles.outputHeader}>
                                        <h4>النتيجة</h4>
                                    </div>
                                    <div className={styles.outputContent}>
                                        {output ? (
                                            <pre className={styles.outputText}>{output}</pre>
                                        ) : (
                                            <div className={styles.noOutput}>
                                                اضغط على "تشغيل" لرؤية النتيجة
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LearnProgramming;
